import React from "react";

export const Dots = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 19"
    >
      <path
        fillRule="evenodd"
        d="M9 5.704c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5zm1.5 3.75c0 .825-.675 1.5-1.5 1.5s-1.5-.675-1.5-1.5.675-1.5 1.5-1.5 1.5.675 1.5 1.5zm-3 5.25c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
